import React from 'react';

const ContactInfoSection = () => {
  return (

<>

<section className="page-title centred">
    <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
    <div className="auto-container">
      <div className="content-box">
      
        <h1>Contact Us</h1>
      </div>
    </div>
  </section>
    <section className="contact-info-section pt_120 pb_90 centred">
      <div className="auto-container">
        <div className="sec-title mb_50">
          <h2>Contact Information</h2>
        </div>
        <div className="row clearfix">
        <div className="col-lg-4 col-md-6 col-sm-12 info-column">
            <div className="info-block-one">
              <div className="inner-box">
                <div className="icon-box"><i className="icon-28"></i></div>
                <h3>Phone Number</h3>
                <p>
                  <a className='text-white' href="tel:+918850328441">+91 8850328441</a>
                </p>
                <p>
                  <a className='text-white' href="tel:+919552526916">+91 9552526916</a>
                </p>
              </div>
            </div>
          </div>
   
          <div className="col-lg-4 col-md-6 col-sm-12 info-column">
            <div className="info-block-one">
              <div className="inner-box">
                <div className="icon-box"><i className="icon-29"></i></div>
                <h3>Email Address</h3>
                <p>
                  <a className='text-white' href="mailto:booking@s9travels.com">booking@s9travels.com</a><br />
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 info-column">
            <div className="info-block-one">
              <div className="inner-box">
                <div className="icon-box"><i className="icon-24"></i></div>
                <h3>Our Location</h3>
                <h4>S9 Travels </h4>
                <p className='text-white'>Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105</p>
              </div>
            </div>
          </div>
      
        </div>
      </div>
    </section>

    <section className="contact-map-section">
      <div className="auto-container">
        <div className="map-inner">
          {/* <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55945.16225505631!2d-73.90847969206546!3d40.66490264739892!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1601263396347!5m2!1sen!2sbd"
            width="600"
            height="535"
            frameBorder="0"
            style={{ border: '0', width: '100%' }}
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
          ></iframe> */}


<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d382426.6144105266!2d73.850991!3d18.656625!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c7423e3b1c35%3A0xda530b24f9fae63e!2ss9%20travels%20pune%20mumbai%20pune%20trip!5e1!3m2!1sen!2sin!4v1742444790735!5m2!1sen!2sin" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </section>
</>
  );
}

export default ContactInfoSection;
